import { Box, Card, Icon,InlineStack } from '@shopify/polaris';
import { ChevronDownIcon, ChevronUpIcon} from '@shopify/polaris-icons';
import React ,{useState} from 'react';

const QuestionBox = ()=> {
    const [question,setQuestion] = useState(fagContent);
    const handleShow = (index)=>{
        setQuestion(question.map((item,ind)=>{
            if(ind === index){
                item.show = !item.show
            }
            return item
        }))

    }
    return (
        <Box>
            <Box className="new_sub_module_title">Frequently asked questions</Box>
            <Box>
                {/* <Box className="new_sub_module_general" style={{marginBottom:'8px'}}>General</Box> */}
                <Box>
                    <Card padding={0}>
                    {question.map((item,ind)=> <Box key={ind} className="question_list_item" onClick={()=>handleShow(ind)}>
                            <InlineStack gap={200} blackAlign='center' align='space-between' wrap={false}>
                                <Box className="question_list_item_title">{item.title}</Box>
                                <Box>
                                    {item.show ? <span ><Icon source={ChevronUpIcon}></Icon></span> :
                                    <span><Icon source={ChevronDownIcon}></Icon></span>}
                                </Box>
                            </InlineStack>
                           {item.show && <Box className="question_list_item_desc">
                            <Box dangerouslySetInnerHTML={{ __html: item.desc }}></Box>
                            {item.children.map((it,k)=><Box key={k} dangerouslySetInnerHTML={{ __html: it }}></Box>)}
                            </Box>}
                        </Box>)}
                    </Card>
                </Box>
            </Box>
        </Box>
    );
}
const fagContent = [
    {
      title:'Do you provide trial days?',
      desc:`Yes, we do! Our Pro, Plus, and Premium plans come with a 7-day free trial. It’s a great opportunity to try them out and see if the services meet your needs. Just make sure to cancel before the trial days end if you don’t want to continue, to avoid any charges. If you decide to keep the plan, you'll be billed at the start of the next billing cycle. `,
      children:[],
      show:false,
    },
    {
      title:'How subscription charges work?',
      desc:`Subscription charges are based on the plan you choose and the <a href='https://www.shopify.com/legal/terms' target='_blank'>Shopify terms of service</a>. When you sign up for a subscription, you're agreeing to pay for the services provided according to a set schedule.`,
      children:[
        "· The whole process happens within the Shopify ecosystem. When you subscribe, you authorize a payment method (like a credit card). Shopify will use this authorized payment method to charge you for the applicable fees.",
        "· These fees are charged regularly depending on the billing cycle of your plan. For example, if it's a monthly plan, you'll be charged approximately once a month. The charges continue until you terminate the services. And you need to make sure all the outstanding fees are paid in full before the service is completely stopped.",
      ],
      show:false,
    },
    {
      title:'Can I change my plan in the middle of the billing cycle?',
      desc:`Yes, you can change your plan at any time based on your needs. Changing your plan follows the rules:`,
      children:[
        `· Upgrading your plan takes effect immediately, and the subscription charge is prorated based on the difference in price and the number of days remaining in the billing cycle. <a href="https://help.shopify.com/zh-CN/manual/your-account/manage-billing/your-invoice/apps#app-prorating-upgrades-downgrades" target="_blank">Learn more</a>`,
        "· Downgrading your plan will take effect after your current plan ends.",
        "· Switching from an annual plan to a monthly plan is considered a downgrade and will only take effect after the annual plan expires. It's a limitation of Shopify.",
      ],
      show:false,
    },
    {
      title:`What's the difference between subscription plans and quota purchases?`,
      desc:`Subscription plans and quota purchases have several key differences that you can consider based on your needs:`,
      children:[
        "· When you subscribe to a plan, you not only receive quotas for sourcing and products importing but also gain access to the plan's functional benefits. When you purchase sourcing or product import quotas alone, you only receive those specific quotas without any additional functional benefits.",
        "· Subscription plans operate on a billing cycle, where you're charged according to your chosen monthly or annual billing period. Quota purchases, on the other hand, are one-time payments with no recurring billing cycle.",
        "· Subscription benefits are only available during the subscription period and have time limitations. Purchased quotas, however, never expire - any unused quotas will remain in your account indefinitely without time restrictions."
      ],
      show:false
    }
  
  ]
export default QuestionBox;
